import { toCurrencyFormat } from "@lib/utils"
import { useBalanceStore } from "@stores/balanceStore"
import Eye from "@components/Eye/Eye"
import { Container, EyeContainer, BalanceText } from "./CollapsingHeader.styles"
import { useTranslation } from "react-i18next"

const CollapsingHeader = ({ balance }: { balance: number | any }) => {
    const { showBalance, toggleShowBalance } = useBalanceStore()
    const notAvailable = typeof balance !== 'number'
    const { t } = useTranslation()

    return (
        <Container>
            <EyeContainer onClick={toggleShowBalance}>
                <Eye active={showBalance} />
            </EyeContainer>
            <BalanceText $showBalance={showBalance}>
                {showBalance ? (notAvailable ? t('page.home.notAvailable') : toCurrencyFormat(balance)) : '*****'}
            </BalanceText>
        </Container>
    )
}

export default CollapsingHeader